import { Middleware, configureStore, EnhancedStore } from "@reduxjs/toolkit";
import createSagaMiddleware from 'redux-saga'
import rootSaga from "./saga/rootSaga";
import rootSlice from "./features/rootSlice";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 

const persistConfig = {
  key: 'idass', 
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootSlice);
const sagaMiddleware = createSagaMiddleware();
type MiddlewareType = Middleware<{}, any, any>; 
type MiddlewareArray = MiddlewareType[]; 

export const store: EnhancedStore = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware: MiddlewareArray = [
      ...getDefaultMiddleware({
        serializableCheck: false
      }),
      sagaMiddleware,
    ];
    return middleware as any; 
  },
});

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);
